import React from 'react';

const About = () => {
    return (
        <div>
            <h1>Comming Soon</h1>
        </div>
    );
};

export default About; <h1>Comming Soon</h1>